import { render } from "./GiftCertificateReceipt.vue?vue&type=template&id=ed3cefaa&scoped=true"
import script from "./GiftCertificateReceipt.vue?vue&type=script&lang=js"
export * from "./GiftCertificateReceipt.vue?vue&type=script&lang=js"

import "./GiftCertificateReceipt.vue?vue&type=style&index=0&id=ed3cefaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed3cefaa"
/* hot reload */
if (module.hot) {
  script.__hmrId = "ed3cefaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed3cefaa', script)) {
    api.reload('ed3cefaa', script)
  }
  
  module.hot.accept("./GiftCertificateReceipt.vue?vue&type=template&id=ed3cefaa&scoped=true", () => {
    api.rerender('ed3cefaa', render)
  })

}

script.__file = "src/views/GiftCertificateReceipt.vue"

export default script